import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-refresh-dialog',
  templateUrl: './refresh-dialog.component.html',
  styleUrls: ['./refresh-dialog.component.css']
})
export class RefreshDialogComponent {
  constructor(
    public dialogRef:MatDialogRef<RefreshDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any){
     
  }
  
  onRefreshCancelClick():void{
    this.dialogRef.close('cancel');
  }

  onDiscardClick():void{
    this.dialogRef.close('discard');
  }

  onSaveClick():void{
    this.dialogRef.close('save');
  }

  onCloseClick():void{
    this.dialogRef.close();
  }
}
